module.exports = __webpack_public_path__ + "files/7ed67ec97760be5da993bfde6daa2554.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-5.png
// module id = 536
// module chunks = 76